import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl, Validators, AbstractControl } from "@angular/forms";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { GtagService } from "../../gtag/gtag.service";
import { ClientInfoModel } from "../../model";
import { AuthService } from "../auth.service";


@Component({
    selector: "app-passwd-change",
    templateUrl: "./passwd-change.component.html",
    styleUrls: ["./passwd-change.component.css"],
    standalone: false
})
export class PasswdChangeComponent implements OnInit {
  registerForm!: FormGroup;
  userData: ClientInfoModel | undefined;

  constructor(
    private authSevice: AuthService,
    private router: Router,
    private gtag: GtagService
  ) {
    this.gtag.pageview2('Change password');
  }

  ngOnInit() {
    this.registerForm = new FormGroup({
      oldPasswd: new FormControl(null, [Validators.required, Validators.minLength(6)]),
      newPasswd: new FormControl(null, [Validators.required, Validators.minLength(6)]),
      newPasswd2: new FormControl(null, [Validators.required, Validators.minLength(6)], this.checkPassword2Validator.bind(this))
    });
  }

  submitForm() {
    if (this.registerForm.valid) {
      const subscr = this.authSevice.changePassword(this.registerForm.get("oldPasswd")?.value, this.registerForm.get("newPasswd")?.value).subscribe({
        next: (data: any) => {
          alert('Пароль пользователя обновлен!');
          this.router.navigate(['/']);
        },
        error: (err: any) => {
          subscr.unsubscribe();
          alert(`Ошибка смены пароля пользователя. ${err}`);
          this.router.navigate(['/']);
        },
        complete: () => {
          subscr.unsubscribe();
        }
      });
    } else {
      for (let fieldName in this.registerForm.controls) {
        this.registerForm.controls[fieldName].markAsTouched();
      }
    }
  }

  checkPassword2Validator(control: AbstractControl): Promise<any> | Observable<any> {
    const promise = new Promise<any>((resolve, reject) => {
      const passwdField = this.registerForm.get("newPasswd");

      if (passwdField?.value && control?.value === passwdField.value) {
        resolve(null);
      } else {
        resolve({ passwd2Mismatch: true });
      }
    });

    return promise;
  }
}